import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const api = axios.create({ baseURL: BASE });
export { api };

const TOKEN_KEY = "rawco_token";

export const setToken = (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); };
export const getToken = () => localStorage.getItem(TOKEN_KEY);

api.interceptors.request.use(cfg => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(r => r, err => {
  if (err.response?.status === 401) {
    setToken(null);
    if (!window.location.pathname.startsWith("/drop")) {
      window.dispatchEvent(new Event("rawco-logout"));
    }
  }
  return Promise.reject(err);
});

export const getStatus = () => api.get("/status").then(r => r.data);
export const getAnalytics = () => api.get("/analytics").then(r => r.data);
export const getTrades = () => api.get("/trades").then(r => r.data);
export const createTrade = (payload) => api.post("/trades", payload).then(r => r.data);
export const closeTrade = (id) => api.post(`/trades/${id}/close`).then(r => r.data);
export const getIssues = () => api.get("/issues").then(r => r.data);
export const fixIssue = (id) => api.post(`/issues/${id}/fix`).then(r => r.data);
export const createIssue = (payload) => api.post("/issues", payload).then(r => r.data);
export const getFinance = () => api.get("/finance").then(r => r.data);
// Stable per-device session id so all chats from one browser stack into a single thread
export const getDeviceSession = () => {
  let s = localStorage.getItem("rawco_session_id");
  if (!s) {
    s = (typeof crypto !== "undefined" && crypto.randomUUID)
      ? crypto.randomUUID()
      : "sess-" + Date.now() + "-" + Math.random().toString(36).slice(2, 10);
    localStorage.setItem("rawco_session_id", s);
  }
  return s;
};

// Voice/chat API. Backend now mounts both /api/jarvis/* and /api/raw/* — we
// prefer /api/raw on the client per the "no Jarvis word anywhere" directive.
export const jarvisChat = (message, session_id, intent_hint) =>
  api.post("/raw/chat", { message, session_id: session_id || getDeviceSession(), intent_hint }).then(r => r.data);

export const listChatSessions = () => api.get("/raw/sessions").then(r => r.data);
export const getChatSession = (sid) => api.get(`/raw/sessions/${sid}`).then(r => r.data);
export const searchChats = (q) => api.get(`/raw/chats/search`, { params: { q } }).then(r => r.data);
export const jarvisTTS = (text, voice_id) =>
  api.post("/raw/tts", { text, voice_id }).then(r => r.data);

// Convenience renames — call sites can migrate gradually.
export const rawChat = jarvisChat;
export const rawTTS = jarvisTTS;

export const getTheme = () => api.get("/theme").then(r => r.data);
export const updateTheme = (payload) => api.post("/theme", payload).then(r => r.data);
export const getWidgets = () => api.get("/widgets").then(r => r.data);

export const login = async (passphrase) => {
  const r = await fetch(`${BASE}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ passphrase }),
  });
  if (!r.ok) {
    let detail = "Authentication failed";
    try { const j = await r.json(); detail = j.detail || detail; } catch {}
    const e = new Error(detail); e.status = r.status; throw e;
  }
  const data = await r.json();
  setToken(data.token);
  return data;
};
export const me = async () => {
  const t = getToken();
  if (!t) throw new Error("no token");
  const r = await fetch(`${BASE}/auth/me`, { headers: { Authorization: `Bearer ${t}` } });
  if (!r.ok) throw new Error("auth check failed");
  return r.json();
};
export const logout = () => setToken(null);

export default api;
